











import Vue from 'vue';
import BaseBtn from './base-button.vue';

export enum ButtonTypes {
  primary = 'primary',
  secondary = 'secondary',
  showAll = 'showAll',
  grayed = 'grayed',
}

const ButtonClasses = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  showAll: 'btn-show-all',
  grayed: 'btn-grayed',
};

export default Vue.extend({
  name: 'Button',
  components: {
    BaseBtn,
  },
  props: {
    btnType: String,
    active: Boolean,
    bShowAll: Boolean,
    bCta: Boolean,
    flatLeft: Boolean,
    iconCssVarName: String,
    withArrowDown: Boolean,
    counter: Number,
  },
  computed: {
    getButtonTypeClass(): string {
      return ButtonClasses[this.btnType as ButtonTypes] ? ButtonClasses[this.btnType as ButtonTypes] : '';
    },

    classesList(): object {
      return {
        button: true,
        active: this.active,
        'flat-left': this.flatLeft,
        [this.getButtonTypeClass as string]: true,
        withIcon: !!this.iconCssVarName,
        withArrowDown: this.withArrowDown,
      };
    },

    cssStyles(): object {
      return this.iconCssVarName
        ? {
            'background-image': `var(${this.iconCssVarName})`,
          }
        : {
            'background-image': 'none',
          };
    },
  },
});
